"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeywordSuggestionsByType = exports.getKeywordSuggestions = void 0;
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var DataApiSaga_1 = require("@/pages/search/sagas/api/DataApiSaga");
var effects_1 = require("redux-saga/effects");
exports.getKeywordSuggestions = function (keyword) {
    var responseSale, responseRent, saleSuggestions_1, rentSuggestions, suggestions, e_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 5]);
                return [4 /*yield*/, effects_1.call(DataApiSaga_1.getSuggestionApi, keyword, SfilterTypeGroup_1.SfilterType.BUY)];
            case 1:
                responseSale = _c.sent();
                return [4 /*yield*/, effects_1.call(DataApiSaga_1.getSuggestionApi, keyword, SfilterTypeGroup_1.SfilterType.RENT)];
            case 2:
                responseRent = _c.sent();
                saleSuggestions_1 = (_a = responseSale.data.suggestions) !== null && _a !== void 0 ? _a : [];
                rentSuggestions = (_b = responseRent.data.suggestions) !== null && _b !== void 0 ? _b : [];
                suggestions = saleSuggestions_1.concat(rentSuggestions.filter(function (it) { return saleSuggestions_1.findIndex(function (it2) { return it2.resultId === it.resultId; }) === -1; }));
                return [2 /*return*/, suggestions.map(function (it) { return ({ id: it.resultId, name: it.result, type: it.type }); }).slice(0, 10)];
            case 3:
                e_1 = _c.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('apiSuggestionError'))];
            case 4:
                _c.sent();
                return [2 /*return*/, []];
            case 5: return [2 /*return*/];
        }
    });
};
exports.getKeywordSuggestionsByType = function (keyword, type) {
    var response, suggestions, hfilterSuggestions, e_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 4]);
                return [4 /*yield*/, effects_1.call(DataApiSaga_1.getSuggestionApi, keyword, type)];
            case 1:
                response = _b.sent();
                suggestions = (_a = response.data.suggestions) !== null && _a !== void 0 ? _a : [];
                hfilterSuggestions = suggestions.map(function (it) { return ({ id: it.resultId, name: it.result, type: it.type }); });
                return [2 /*return*/, hfilterSuggestions];
            case 2:
                e_2 = _b.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('apiSuggestionError'))];
            case 3:
                _b.sent();
                return [2 /*return*/, []];
            case 4: return [2 /*return*/];
        }
    });
};
